"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Utils = void 0;

var asymmetricEncryption_1 = require("./asymmetricEncryption");

var CryptoJS = require("crypto-js");
/**
 * Utils Class
 */


var Utils;

(function (Utils) {
  Utils.decryptSecret = function (secret, signer) {
    try {
      var decrypted = CryptoJS.AES.decrypt(secret, signer);
      var plaintext = decrypted.toString(CryptoJS.enc.Utf8);
      return plaintext;
    } catch (error) {
      throw error;
    }
  };

  Utils.encryptSecret = function (secret, signer) {
    try {
      var ciphertext = CryptoJS.AES.encrypt(secret, signer);
      return ciphertext.toString();
    } catch (error) {
      throw error;
    }
  };

  Utils.asymmetricEncryption = asymmetricEncryption_1.AsymmetricEncryption;
})(Utils = exports.Utils || (exports.Utils = {}));